'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userTimesheets = require('./user-timesheets.html');

var _userTimesheets2 = _interopRequireDefault(_userTimesheets);

var _userTimesheets3 = require('./user-timesheets.controller');

var _userTimesheets4 = _interopRequireDefault(_userTimesheets3);

require('./user-timesheets.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userTimesheetsComponent = {
  restrict: 'E',
  bindings: {
    userId: '<'
  },
  template: _userTimesheets2.default,
  controller: _userTimesheets4.default,
  controllerAs: 'vm'
};

exports.default = userTimesheetsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-timesheets/user-timesheets.component.js
 **/